import { useTranslation } from "react-i18next";

import "./style.scss";

type CityLocationProps = {
	showCity: boolean;
	locationName: string;
	favCity?: React.ReactElement;
	type?: string;
};

export const CityLocation = ({
	showCity,
	locationName,
	favCity,
	type,
}: CityLocationProps) => {
	const { t } = useTranslation();

	return (
		<div className="city-location-div">
			<p className="city-location">
				{t("forecast")} {locationName} {showCity ? type && type : null}
			</p>

			{favCity}
		</div>
	);
};

export default CityLocation;
